import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { SupplementaryEquipment } from './../../model/supplementary-equipment';
import { ParamterType } from './../../model/paramter-type.enum';
import { TranslationService } from '@sdbn/common';
import { RegistrationStepperModel } from './../../model/registration-step-model';
import { TransportRegistration } from './../../model/transport-registration';
import { Component, OnInit, Input } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { ConfigurationService } from '@sdbn/appclient';
import { MessagingProvider } from 'src/tmc-yard/client/model/messagingprovider';
import { environment } from 'src/environments/environment';
import { TransportPlanningType } from 'src/tmc-yard/common/model/transport.model';

@Component({
  selector: 'app-supplementary-equipment',
  templateUrl: './supplementary-equipment.component.html',
  styleUrls: ['./supplementary-equipment.component.scss']
})
export class SupplementaryEquipmentComponent implements OnInit {

  @Input() registration: TransportRegistration;
  @Input() stepperModel: RegistrationStepperModel;

  clientParameters = TMCClientParameters;
  planningType = TransportPlanningType;

  constructor(
    private tmcContextService: TmcContextService,
    public translationService: TranslationService,
    public cps: ConfigurationService) { }

  ngOnInit() {
    this.stepperModel.stepCompleted = () => {
      return this.isStepCompleted();
    };

    this.stepperModel.beforeShowNextStep = () => {
      const subject = new AsyncSubject<boolean>();
      subject.next(true);
      subject.complete();
      return subject;
    };
  }

  isStringParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.STRING;
  }

  isNumberParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.NUMBER;
  }

  isNoSupplementaryEquipmentHandoutDisabled(): boolean {
    if (this.registration.supplementaryEquipments != null
      && this.registration.supplementaryEquipments.length > 0
      && this.registration.supplementaryEquipments.some(se => se.selected)) {
      return true;
    }
    return false;
  }

  isNoSupplementaryEquipmentHandoutSelected(): boolean {
    return this.registration.noSupplementaryEquipmentHandout === true;
  }

  private isStepCompleted(): boolean {

    // wenn keine "Bestätigung Begleitmittel nötig" konfiguriert
    if (!this.cps.isEnabled(TMCClientParameters.FEATURE_FORCE_SUPPLEMENTARY_EQUIPMENT_CONFIRMATION, true)) {

      // ungültige Eingaben prüfen
      for (const se of this.registration.supplementaryEquipments) {
        if (se.selected) {
          if (se.parameter1Type !== ParamterType.NONE && (se.parameter1Value == null || se.parameter1Value.length === 0)) {
            return false;
          }
        }
      }

      return true;
    }

    // bei Vorabanmeldung muss nur geprüft werden, wenn "jetzt einbuchen" gesetzt ist
    if (this.registration.transport.timing.planningType === TransportPlanningType.IN_ADVANCE && !this.registration.registerNow) {
      return true;
    }


    if (this.registration.noSupplementaryEquipmentHandout) {
      return true;
    }

    if (this.registration.supplementaryEquipments.length === 0) {
      return true;
    }

    let validCount = 0;
    for (const se of this.registration.supplementaryEquipments) {
      if (se.selected) {
        if (se.parameter1Type !== ParamterType.NONE && (se.parameter1Value == null || se.parameter1Value.length === 0)) {
          return false;
        } else {
          validCount += 1;
        }
      }
    }

    return validCount > 0;
  }

  availableMessagingProvider(): Array<MessagingProvider> {
    return this.tmcContextService.getAvailableMessagingProvider();
  }

  getMessagingProviderLabel(messagingProvider: MessagingProvider): string {
    if (messagingProvider.dictionaryKey) {
      return this.translationService.translate(messagingProvider.label);
    }
    return messagingProvider.label;
  }

  /** translates the messaging language keys using the current language and orders them alpabetically */
  public getMessagingLanguagesOrdererByCurrentTranslation() {
    const languages = new Array<string>(...environment.messagingLanguages);

    return languages.sort((a, b) => {
      const ta = this.translationService.translate('common.enum.language.' + a);
      const tb = this.translationService.translate('common.enum.language.' + b);
      return ta > tb ? 1 : ta === tb ? 0 : -1;
    });
  }

}
